"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const groupBy_1 = __importDefault(require("lodash/groupBy"));
const map_1 = __importDefault(require("lodash/map"));
const getDayNumber_1 = __importDefault(require("../getDayNumber"));
/**
 * Returns off days for a branch
 * @param {Array} timings
 * @returns {Array} eg. [0, 6]
 */
const getOffDays = (timings) => {
    const offData = (0, groupBy_1.default)(timings, 'open').false;
    return (0, map_1.default)(offData, (item) => (0, getDayNumber_1.default)((0, get_1.default)(item, 'day')));
};
exports.default = getOffDays;
